import { useState } from 'react';

export const useInputWithFocus = (initialValue: boolean[]) => {
    const [isFilled, setIsFilled] = useState(initialValue);

    const handleFocus = (index: number) => {
        const filledArray = [...isFilled];
        filledArray[index] = true;
        setIsFilled(filledArray);
    };

    const handleBlur = () => {
        setIsFilled([]);
    };

    return { isFilled, handleFocus, handleBlur };
};
